import { useState } from "react";
import { LatLng } from "leaflet";
import { useMapEvents } from "react-leaflet";
import styled from "styled-components";

interface OpacityProps {}

export const CoordinatesControl = (props: OpacityProps) => {
  const [latlng, setLatLng] = useState<LatLng | null>(null);
  useMapEvents({
    mousemove: (event) => setLatLng(event.latlng),
  });

  function format(coordinate: number) {
    const precision = 5;
    return Math.round(coordinate * Math.pow(10, precision)) / Math.pow(10, precision);
  }

  return render();

  function render() {
    if (!latlng) return null;
    return (
      <Styles>
        LatLon: {format(latlng?.lat)} {format(latlng?.lng)}
      </Styles>
    );
  }
};

const Styles = styled.div`
  padding: 2px 5px 1px;
  border-left: 2px solid #777;
  background-color: rgba(255, 255, 255, 0.5);
  color: black;
  transform: translateX(-5px); // translateY(10px);
  font-size: 11px;
`;
